import React from "react";
import {NavLink} from "react-router-dom";
import ContentBox from "../../../../../../components/content-box/ContentBox";
import PageActions from "../../../../../base/PageActions";
import Breadcrumbs from "../../../../../../components/breadcrumbs/Breadcrumbs";
import _image_service from "../../../../../../services/ImageService";
import '../../../../../styles/Common.scss';
import '../../WorldPages.scss';
import './MagicClassesPage.scss'

interface MagicClassesPageProps {
}

const MagicClassesPage = (props: MagicClassesPageProps) => {

    const page: PageActions = new PageActions({
        title: `Casarok: Magic Classes - Chase the Fox`,
        description: "Learn about the various special magic classes in Casarok's magic system!",
        keywords: ["casarok", "magic", "magic class", "magic system", "magical class", "class system"],
        imgSrc: `chase/world/magic/classes/preview.png`,
        url: `world/magic/classes`
    });

    return page.generateMetaContent(
        <>
            <ContentBox header="Magical Classes">
                <Breadcrumbs path={page.getUrl()}/>
                <div className="world-page-static">
                    <p>
                        With so many <NavLink className="world-link"
                                              to="/world/magic/schools">schools</NavLink> and <NavLink
                                className="world-link"
                                to="/world/magic/elements">elements</NavLink> in
                        Casarok, it has been taken upon by the International Council of Magic to organize and classify
                        various combinations and uses within the realm of magic. The following are examples of special
                        jobs that a magic user can be categorized as when learning and using magic:
                    </p>
                    <div className="right">
                        <img className="spellcaster-pic"
                             src={_image_service.getCdnImageSrc("chase/world/magic/classes/spellcaster.png")}
                             alt="Magic User"/>
                    </div>
                    <ul className="spaced">
                        <li>
                            <NavLink className="world-link" to="/world/magic/classes/injuja">Injuja</NavLink>
                        </li>
                        <li>
                            <NavLink className="world-link" to="/world/magic/classes/lunar-magus">Lunar-Magus</NavLink>
                        </li>
                        <li>
                            <NavLink className="world-link" to="/world/magic/schools">Mage</NavLink>
                        </li>
                        <li>
                            <NavLink className="world-link" to="/world/magic/classes/osteomancer">Osteomancer</NavLink>
                        </li>
                        <li>
                            <NavLink className="world-link" to="/world/magic/classes/solar-magus">Solar-Magus</NavLink>
                        </li>
                        <li>
                            <NavLink className="world-link" to="/world/magic/schools">Thaumaturge</NavLink>
                        </li>
                        <li>
                            <NavLink className="world-link" to="/world/magic/classes/wiccan">Wiccan</NavLink>
                        </li>
                        <li>
                            <NavLink className="world-link" to="/world/magic/classes/witch">Witch</NavLink>
                        </li>
                        <li>
                            <NavLink className="world-link" to="/world/magic/schools">Wizard</NavLink>
                        </li>
                    </ul>
                </div>
            </ContentBox>
        </>
    );
}

export default MagicClassesPage;